import BaseBehavior from '../../../framework/base/base';

// eslint-disable-next-line no-useless-escape
export const formattingTokens = /(\[[^\[]*\])|(\\)?(MM?M?M?|DD|ddd?d?|YYYY|YY|HH?|mm?|ss?|.)/g;

const DEFAULT_LOCALE = 'en-gb';

export const DateFormatter = {
	locale: DEFAULT_LOCALE,
	localesConfigs: {
		[DEFAULT_LOCALE]: {
			months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
				'_'
			),
			monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
			weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
			weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
			weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_')
		}
	},
	formatTokens: {},
	setLocale(htmlLocale) {
		let locale = htmlLocale ? htmlLocale.toLowerCase() : DEFAULT_LOCALE;
		if (this.localesConfigs[locale]) {
			this.locale = locale;
			return;
		}
		[locale] = locale.split('-');
		if (this.localesConfigs[locale]) {
			this.locale = locale;
			return;
		}
		this.locale = DEFAULT_LOCALE;
	},
	defineLocale(name, config) {
		this.localesConfigs[name] = config;
	},
	addFormatToken(token, callback) {
		this.formatTokens[token] = callback;
	},
	removeFormattingTokens(input) {
		// add test
		if (input.match(/\[[\s\S]/)) {
			return input.replace(/^\[|\]$/g, '');
		}
		return input.replace(/\\/g, '');
	},
	format(date, format) {
		const tokens = format.match(formattingTokens);

		return tokens.reduce(
			(formattedDate, token) =>
				formattedDate +
				(this.formatTokens[token]
					? this.formatTokens[token](date, format, this.localesConfigs[this.locale])
					: this.removeFormattingTokens(token)),
			''
		);
	}
};

const arMonths = [
	'يناير',
	'فبراير',
	'مارس',
	'أبريل',
	'مايو',
	'يونيو',
	'يوليو',
	'أغسطس',
	'سبتمبر',
	'أكتوبر',
	'نوفمبر',
	'ديسمبر'
];

DateFormatter.defineLocale('ar', {
	months: arMonths,
	monthsShort: arMonths,
	weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_')
});

DateFormatter.defineLocale('cs', {
	months: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
		'_'
	),
	monthsShort: 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_')
});

DateFormatter.defineLocale('da', {
	months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
		'_'
	),
	monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_')
});

DateFormatter.defineLocale('de', {
	months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
		'_'
	),
	monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_')
});

DateFormatter.defineLocale('fr', {
	months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
		'_'
	),
	monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_')
});

DateFormatter.defineLocale('hu', {
	months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
		'_'
	),
	monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_')
});

DateFormatter.defineLocale('it', {
	months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
		'_'
	),
	monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_')
});

DateFormatter.defineLocale('ja', {
	months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	weekdaysMin: '日_月_火_水_木_金_土'.split('_')
});

DateFormatter.defineLocale('nb', {
	months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
		'_'
	),
	monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_')
});

DateFormatter.defineLocale('nl', {
	monthsShortWithDots: 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	monthsShortWithoutDots: 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
		'_'
	),
	monthsShort(date, format) {
		if (/-MMM-/.test(format)) {
			return this.monthsShortWithoutDots;
		}
		return this.monthsShortWithDots;
	},
	weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_')
});

DateFormatter.defineLocale('pl', {
	monthsNominative: 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
		'_'
	),
	monthsSubjective: 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
		'_'
	),
	months(date, format) {
		if (/D MMMM/.test(format)) {
			return this.monthsSubjective;
		}
		return this.monthsNominative;
	},
	monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_')
});

DateFormatter.defineLocale('ru', {
	months: {
		format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
			'_'
		),
		standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
			'_'
		)
	},
	monthsShort: {
		// по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
		format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
		standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	},
	weekdays: {
		standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
		format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
		isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	},
	weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_')
});

DateFormatter.defineLocale('sk', {
	months: 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
		'_'
	),
	monthsShort: 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_'),
	weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_')
});

DateFormatter.defineLocale('zh', {
	months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	weekdaysMin: '日_一_二_三_四_五_六'.split('_')
});

DateFormatter.addFormatToken('YYYY', date => date.getFullYear().toString());
DateFormatter.addFormatToken('YY', date => date.getFullYear().toString().substr(2, 2));

// eslint-disable-next-line no-useless-escape
const MONTHS_IN_FORMAT = /DD?(\[[^\[\]]*\]|\s)+MMMM?/;

// January February ... November December
DateFormatter.addFormatToken('MMMM', (date, format, localeConfig) => {
	if (typeof localeConfig.months === 'function') {
		return localeConfig.months(date, format)[date.getMonth()];
	}
	if (Array.isArray(localeConfig.months)) {
		return localeConfig.months[date.getMonth()];
	}
	return (localeConfig.months.isFormat || MONTHS_IN_FORMAT).test(format)
		? localeConfig.months.format[date.getMonth()]
		: localeConfig.months.standalone[date.getMonth()];
});

// Jan Feb ... Nov Dec
DateFormatter.addFormatToken('MMM', (date, format, localeConfig) => {
	if (typeof localeConfig.monthsShort === 'function') {
		return localeConfig.monthsShort(date, format)[date.getMonth()];
	}
	if (Array.isArray(localeConfig.monthsShort)) {
		return localeConfig.monthsShort[date.getMonth()];
	}
	return MONTHS_IN_FORMAT.test(format)
		? localeConfig.monthsShort.format[date.getMonth()]
		: localeConfig.monthsShort.standalone[date.getMonth()];
});

export const pad = (n, width, z = '0') => {
	const sn = n.toString();
	return sn.length >= width ? sn : new Array(width - sn.length + 1).join(z) + sn;
};

DateFormatter.addFormatToken('M', date => (date.getMonth() + 1).toString());
DateFormatter.addFormatToken('MM', date => pad(date.getMonth() + 1, 2).toString());

DateFormatter.addFormatToken('D', date => date.getDate().toString());
DateFormatter.addFormatToken('DD', date => pad(date.getDate(), 2));

// Sunday Monday ... Friday Saturday
DateFormatter.addFormatToken('dddd', (date, format, localeConfig) => {
	if (Array.isArray(localeConfig.weekdays)) {
		return localeConfig.weekdays[date.getDay()];
	}
	return localeConfig.weekdays.isFormat.test(format)
		? localeConfig.weekdays.format[date.getDay()]
		: localeConfig.weekdays.standalone[date.getDay()];
});

// Sun Mon ... Fri Sat
DateFormatter.addFormatToken(
	'ddd',
	(date, format, localeConfig) => localeConfig.weekdaysShort[date.getDay()]
);

// Su Mo ... Fr Sa
DateFormatter.addFormatToken(
	'dd',
	(date, format, localeConfig) => localeConfig.weekdaysMin[date.getDay()]
);

// Time
DateFormatter.addFormatToken('HH', date => pad(date.getHours(), 2)); // 00 01 ... 22 23
DateFormatter.addFormatToken('H', date => date.getHours().toString()); // 0 1 ... 22 23

DateFormatter.addFormatToken('mm', date => pad(date.getMinutes(), 2)); // 00 01 ... 58 59
DateFormatter.addFormatToken('m', date => date.getMinutes().toString()); // 0 1 ... 58 59
DateFormatter.addFormatToken('ss', date => pad(date.getSeconds(), 2)); // 00 01 ... 58 59
DateFormatter.addFormatToken('s', date => date.getSeconds().toString()); // 0 1 ... 58 59

DateFormatter.setLocale(document.querySelector('html').getAttribute('lang'));

export const getOffsetInformation = date => {
	const offset = date.getTimezoneOffset();
	let offsetInformation = '(UTC';
	if (offset) {
		offsetInformation += offset > 0 ? '-' : '+';
		offsetInformation += pad(Math.floor(Math.abs(offset) / 60), 2);
		const minutes = offset % 60;
		if (minutes) {
			offsetInformation += ':' + Math.abs(minutes);
		}
	}
	offsetInformation += ')';
	return offsetInformation;
};

/**
 * Split date fragments from a string
 * to prevent browser from parsing it
 *
 * @param {string} date in ISO format
 */
export const parseIsoDate = date => {
	const utc = /Z| UTC$/;
	const args = date
		.replace(utc, '')
		.replace(/[^\d]/g, ' ')
		.split(' ')
		.map(v => parseInt(v, 10));

	args[1] -= 1; // Months are indexed from 0

	if (date.match(utc)) {
		return new Date(Date.UTC(...args));
	}

	return new Date(...args);
};

const ISODateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z?$/;

export const isValidDateString = s => !!(s && ISODateFormat.test(s));

const defaultTemplate = 'YYYY-MM-DD HH:mm:ss';

const upperCaseFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

export class TimeFormat extends BaseBehavior {
	constructor(element) {
		super(element);

		const IsoString = element.getAttribute('datetime');

		if (!isValidDateString(IsoString)) {
			throw new Error(
				'TimeFormat got invalid date-string in "datetime" attribute, expected format "YYYY-DD-MMTHH:mm:ii" or "YYYY-DD-MMTHH:mm:iiZ".'
			);
		}
		const noConversionToLocal = element.dataset.shouldConvertToLocal === 'false';
		const date = noConversionToLocal ? new Date(IsoString) : parseIsoDate(IsoString);
		const formattedDate = DateFormatter.format(date, element.dataset.template || defaultTemplate);
		const { timezone } = element.dataset;
		let finalHTML = upperCaseFirstLetter(formattedDate);

		if (element.dataset.showUtc === 'true') {
			finalHTML +=
				noConversionToLocal && timezone ? ' ' + timezone : ' ' + getOffsetInformation(date);
		}
		this.element.innerHTML = finalHTML;

		this.addEventListeners();

		if (this.element.dataset.tooltip) {
			const offsetInformation =
				this.element.dataset.tooltipOffsetInformation || getOffsetInformation(date);
			// setAttribute instead of this.element.dataset.tooltip += because of IE11
			this.element.setAttribute(
				'data-tooltip',
				`${this.element.dataset.tooltip} ${offsetInformation}`
			);
		}
	}

	addEventListeners() {
		if (this.element.dataset.tooltipEnabled?.toLowerCase() === 'true') {
			this.addEventListener(this.element, 'click', evt => {
				evt.preventDefault();
				evt.stopPropagation();
			});
		}
	}

	removeEventListeners() {
		this.removeEventListener(this.element, 'click');
	}

	cleanup() {
		this.removeEventListeners();
	}
}

export default TimeFormat;
